module.exports = __webpack_public_path__ + "img/home-recommend-music-download.2a3bc563.svg";